var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMail = function SvgMail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.077 24.5H10.923a8 8 0 0 0-8 8v62a8 8 0 0 0 8 8h106.154a8 8 0 0 0 8-8v-62a8 8 0 0 0-8-8m-106.154 8h106.154v62H10.923z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m120.152 36.228 3.646 7.12-44.683 22.88c-8.174 4.186-17.437 4.03-25.712-.384l-.42-.228L7.608 40.515l3.873-7 45.375 25.1c5.948 3.291 12.424 3.515 18.25.674l.363-.182z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export default ForwardRef;